import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const PLATFORM_LABELS = {
  instagram: "Instagram",
  facebook: "Facebook",
  x: "X (Twitter)",
  linkedin: "LinkedIn",
  tiktok: "TikTok",
  youtube: "YouTube",
  reddit: "Reddit",
  google: "Web / Presse",
};

export const STATUS_CONFIG = {
  gefunden: {
    label: "Gefunden",
    className: "bg-amber-50 text-amber-700 border-amber-200",
    dot: "bg-amber-500",
    hex: "#f59e0b",
  },
  angeschrieben: {
    label: "Angeschrieben",
    className: "bg-blue-50 text-blue-700 border-blue-200",
    dot: "bg-blue-500",
    hex: "#3b82f6",
  },
  angemahnt: {
    label: "Angemahnt",
    className: "bg-orange-50 text-orange-700 border-orange-200",
    dot: "bg-orange-500",
    hex: "#f97316",
  },
  rechtsabteilung: {
    label: "An Rechtsabteilung",
    className: "bg-rose-50 text-rose-700 border-rose-200",
    dot: "bg-rose-600",
    hex: "#e11d48",
  },
  geloest: {
    label: "Gelöst",
    className: "bg-emerald-50 text-emerald-700 border-emerald-200",
    dot: "bg-emerald-500",
    hex: "#10b981",
  },
};

export const STATUS_FLOW = ["gefunden", "angeschrieben", "angemahnt", "rechtsabteilung", "geloest"];

export const ROLES = ["admin", "compliance", "legal", "viewer"];
export const ROLE_LABELS = {
  admin: "Administrator",
  compliance: "Compliance",
  legal: "Rechtsabteilung",
  viewer: "Nur Lesen",
};
export const ROLE_DESC = {
  admin: "Voller Zugriff inkl. Benutzerverwaltung",
  compliance: "Voller Zugriff auf Fälle, Scans & Zeitpläne",
  legal: "Voller Zugriff auf Fälle, Scans & Zeitpläne",
  viewer: "Nur Lesezugriff – keine Änderungen",
};

export const WEEKDAYS = [
  { value: 0, short: "Mo", label: "Montag" },
  { value: 1, short: "Di", label: "Dienstag" },
  { value: 2, short: "Mi", label: "Mittwoch" },
  { value: 3, short: "Do", label: "Donnerstag" },
  { value: 4, short: "Fr", label: "Freitag" },
  { value: 5, short: "Sa", label: "Samstag" },
  { value: 6, short: "So", label: "Sonntag" },
];

export function formatDateTime(iso) {
  if (!iso) return "–";
  try {
    return new Date(iso).toLocaleString("de-DE", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
}
